<template>
  <div :class="$style.rowSpacing">
    <CheckboxWithLabel
      :disabled="alreadyHasPosixGroup"
      label="Create Linux group for this user group"
      :tooltip="$options.tooltip"
      :value="hasPosixGroup"
      @change="handlePosixGroupChange"
    />
    <transition
      :name="$style.groupInputs"
    >
      <div
        v-show="hasPosixGroup"
        :class="$style.inputRow"
      >
        <InputValidator
          :class="$style.half"
          :config="{
            attribute: 'posixGroupName',
            label: 'Group Name',
            name: 'Posix Group Name',
            readonly: alreadyHasPosixGroup,
            scope: 'PosixGroup',
            validate: 'required|max:16|alpha_dash|firstCharIsNotDash|nameCannotBeGroupName',
            value: posixGroupName,
          }"
          @InputValidatorModel="handlePosixInputChange"
        />
        <InputValidator
          :class="$style.half"
          :config="{
            attribute: 'posixGroupId',
            label: 'Group GID',
            name: 'Posix Group GID',
            readonly: alreadyHasPosixGroup,
            scope: 'PosixGroup',
            validate: 'required|numeric',
            value: posixGroupId,
          }"
          @InputValidatorModel="handlePosixInputChange"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import CheckboxWithLabel from 'client/components/FormValidation/CheckboxWithLabel.vue';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

const userGroupModel = StoreModelMap[ItemTypeConsts.userGroup];

export default {
  name: 'PosixGroupInput',

  inject: ['$validator'],

  components: {
    CheckboxWithLabel,
    InputValidator,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data() {
    return {
      showGroupInputs: false,
    };
  },

  computed: {
    ...mapState(userGroupModel, {
      alreadyHasPosixGroup: state => state.previousItem.hasPosixGroup,
      hasPosixGroup: state => state.item.hasPosixGroup,
      posixGroupId: state => state.item.posixGroupId,
      posixGroupName: state => state.item.posixGroupName,
    }),
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  beforeMount() {
    this.$validator.extend('firstCharIsNotDash', {
      getMessage: 'Linux Group Name may not start with a hyphen.',
      validate: value => !String(value).match(/^-/),
    });

    this.$validator.extend('nameCannotBeGroupName', {
      getMessage: 'Name and Linux Group Name must be different.',
      validate: value => String(value) !== this.item.name,
    });
  },

  methods: {
    handlePosixGroupChange(checked) {
      this.setItemField({ key: 'hasPosixGroup', value: checked });
    },

    handlePosixInputChange(value, key) {
      this.setItemField({ key, value });
    },
  },

  tooltip: {
    text: 'Linux Group settings cannot be edited after group creation.',
  },
};
</script>
<style module>
@import '../../css/flex.css';
@import '../../components/FormValidation/css/formFields.css';

@value (slowEaseFade, transformTransition) from '~css/transitions.css';

.groupInputs {
  max-height: 40px;
  padding-bottom: 20px;
}

.groupInputs-enter-active,
.groupInputs-leave-active {
  transition: slowEaseFade;
}

.groupInputs-enter,
.groupInputs-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
